import CardWrapper from './CardWrapper';

export default CardWrapper;
